module.exports = {
    "index": {
        "login": "Member rankings",
        "regist": "Gift for new users",
        "user": "new team",
        "jiang": "member",
        "set": "Remark",
        "lingqyu": "No remarks entered , please set",
        "liji": "is not entered , please set it",
        "list": {
            "0": "Deposit time",
            "1": "Debit card information",
            "2": "Note : Bitcoin wallet and USDT wallet recharge. Complimentary 10% of the recharge principal + USD 20 handling fee",
            "3": "I'm sorry I didn't get it , please continue to buy it",
            "4": "Dollar",
            "5": "The order volume on the first day has reached 20, and no further orders can be placed.",
            "6": "Submit now"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "Bank account",
                "1": "Cancel the order"
            },
            "tianjia": {
                "0": "address",
                "1": "No address entered , please set it"
            },
            "tiqu": {
                "0": "please enter",
                "1": "The account balance is less than 200, please recharge before grabbing an order"
            }
        },
        "guanyu": {
            "title1": "Please check account balance",
            "text1": "Insufficient available account balance",
            "title2": "The order has been processed , please refresh the page",
            "text2": "Parameter error , please confirm the order number"
        },
        "title_content": {
            "0": "Order number does not exist",
            "1": "Failed to grab the order . There is insufficient inventory in the price range of this category.",
            "2": "Order grabbing failed ! Please try again later"
        },
        "content": {
            "0": "Grab order successfully",
            "1": "of the order is insufficient, please order again.",
            "2": "grab it"
        },
        "dugengduo": "Insufficient membership level balance",
        "darkgrey": {
            "1": {
                "title": "Order grabbing has been terminated",
                "text": "Check-in time"
            },
            "2": {
                "title": "get red envelope",
                "text": "Go to recharge"
            },
            "3": {
                "title": "Look again",
                "text": "The account balance needs to be greater than 200 to unlock"
            },
            "4": {
                "title": "Next step",
                "text": "Verification code"
            },
            "5": {
                "title": "please enter verification code",
                "text": "Graphical verification code verification failed , please re-enter"
            },
            "6": {
                "title": "Request successful",
                "text": "Mobile phone number format is incorrect"
            }
        },
        "into": {
            "yibiaoban": "account does not exist",
            "nihao": "User does not exist",
            "yue": "User disabled",
            "shebeigong": "This account is already logged in elsewhere",
            "riqi": "The password has been entered incorrectly too many times in a row. Please",
            "gaishu": "Try again in minutes",
            "kaicaizong": "wrong password",
            "xiaoshili": "sign in suceesfully",
            "rili": "Verification code does not exist",
            "zhouli": "Verification code error",
            "yeli": "Verification code invalid",
            "tuilian": "The invitation code does not exist",
            "hezuo": "The recommended user has been deactivated",
            "fukuanxin": "Bad request",
            "tianjiadi": "Please log in first",
            "gengxin": "This account has been disabled",
            "yibiaoti": "The trading function of this account has been frozen",
            "yaoqing": "This account has unfinished orders and cannot continue to grab orders.",
            "yaoqingren": "Balance is less than",
            "shijian": "Unable to continue trading",
            "choujiangci": "Insufficient number of transactions for membership level",
            "choujianggai": "interest treasure",
            "tuijianren": "Early withdrawal before expiration , no profit, handling fee is",
            "xiejie": "The minimum investment amount for this product",
            "jiriqi": "The maximum investment amount for this product",
            "dianjifu": "Data anomaly",
            "tishi": {
                "1": "Insufficient available balance",
                "2": "Successful operation",
                "3": "Operation failed ! Please check your account balance"
            },
            "chongzhijin": "Starting investment",
            "chongzhigai": "operate",
            "nindeyu": "Interest balance transfer",
            "mianchong": "Repeat operation",
            "mianchongci": "Transferring interest balance",
            "chongzhili": {
                "title": "Parameter error",
                "jine": "prohibited from",
                "shijian": "Perform the current operation outside of the time period",
                "zhauntai": "The recharge cannot be less than"
            },
            "yijiangli": "The recharge cannot be greater than",
            "yiqizhuan": "Image format error",
            "jianglili": "Submission failed , please try again later",
            "shezhi": "WeChat Pay",
            "mimashe": "Pay with Ali-Pay",
            "dangqianmishu": "WeChat cash withdrawal",
            "xinmi": "Alipay cash withdrawal",
            "shuxinmi": "No bank card information has been added yet",
            "quemi": "No transaction password set",
            "shuquemi": "The membership level withdrawal limit is",
            "dainyou": "The current level withdrawal needs to be completed",
            "dianyoudi": "orders",
            "shudainyou": "Insufficient balance",
            "fukuanshe": "The number of withdrawals for member level today is insufficient.",
            "bitedi": "Account holder’s name is required",
            "shugukuan": "The maximum length of the account holder’s name is 30 characters.",
            "jisheng": "Bank name is required",
            "qiangou": "Bank card number is required",
            "xiacixiaoshi": "Mobile phone number is required",
            "yingjian": "Bank card number already exists",
            "zonggong": "operation failed",
            "maidian": "Page does not exist",
            "yingjiancheng": "Get rebates",
            "zhuanzhang": "Not logged in user",
            "dianfeizong": "Please do not resubmit",
            "zhuanzhangti": "get success",
            "zhaunzhangfeiyong": "fail",
            "zuidifei": "success",
            "tikuanjin": "This name and bank card have been bound to another account",
            "zuidixian": "Unable to delete default shipping address",
            "bijieshou": "Incorrect login password",
            "quezhi": "Signed in today",
            "querenti": "Sign in successfully and get a red envelope",
            "yiwen": "Sign in successfully",
            "tili": "All your withdrawal orders",
            "yaohaoyou": "Verification passed",
            "yaohuoci": "Please log in to grab an order",
            "yihanwei": "Order grabbing failed , please try again later",
            "gongxihuo": "Order grabbing failed , product inventory insufficient"
        },
        "taocan": {
            "title": "Mobile number has been registered",
            "text": "Only one text message can be sent within 1 minute",
            "kuanggong": "Sent successfully",
            "liliang": "Failed to send",
            "jiage": "SMS sent successfully",
            "yingli": "Incomplete parameters"
        },
        "baoming": {
            "title": "The server space is not supported . Please confirm that it supports curl or fsocket. Contact your space provider to solve the problem or change the space.",
            "text": "Account has expired"
        }
    },
    "login": {
        "yongdeng": "IP address restrictions",
        "quedeng": "Content contains sensitive words",
        "yonghu": "Product parameter abnormality",
        "mima": "The available balance is insufficient , please top up first",
        "xieyi": "Today's amount",
        "tiaokaun": "Number of users today",
        "tongyi": "Number of people online today",
        "wangmi": "Year",
        "zhaomi": "moon",
        "zhaomiti": "Sign in",
        "feihuiyuan": "continuous",
        "lizhi": "Signed in today and received 1 red envelope",
        "chaunghu": "day",
        "yonghumming": "one",
        "mimafu": "two",
        "zhanghaoyou": "Four",
        "jinggao": "five"
    },
    "botton": {
        "lianjie": {
            "0": "six",
            "1": "Signed in",
            "2": "Already signed in today",
            "3": "transfer out"
        },
        "zhichi": {
            "0": "transfer in",
            "1": "Mall"
        }
    },
    "content": {
        "zhichu": "one",
        "jiage": "Second-rate",
        "yinliang": "No permission",
        "jiaoyizhe": "Setup message",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "One account can be grabbed in 1 day",
        "choujiang": "generation commission",
        "jiangli": "Level 1",
        "chongzhi": "Three generations of commissions",
        "zhuanzhang": "Level three",
        "yongjin": "Upload payment screenshot",
        "lijikaishi": "Pull up to refresh",
        "mianfei": "The next level of exclusive channel can get higher commissions",
        "kaishi": "Pull down to rearrange",
        "lianjie": "Subordinate commission rebate",
        "zhoumo": "Can not be empty",
        "shizhi": "Dedicated customer service",
        "jiaoyi": "The passwords entered twice are inconsistent",
        "zhichi": "The fund passwords entered twice are inconsistent",
        "fuzhi": "personal information",
        "dangqian": "In order to prevent platform supervision, such as matching orders",
        "wanshan": "Please confirm the transaction password",
        "buyizhi": "Buyer's message",
        "ziyou": "learn",
        "mai": "Second generation commission",
        "yaoqing": "Level 2",
        "yihan": "QR code",
        "gongxi": "Transaction password management",
        "huifu": "Transaction details"
    },
    "tanchuang": {
        "one": "Number of orders taken today",
        "two": "Already grabbed commission today",
        "title1": "Today's results",
        "title2": "Today's earnings"
    },
    "weishangxian": {
        "weishangxian": "After the above operation is completed, please contact customer service to upgrade the score.",
        "yueshouru": "price",
        "meiyuan": "More tasks",
        "qianggouzhong": "mission hall",
        "chongzhidizhi": "Task rebate",
        "jine": "coupon",
        "bufu": "Membership is valid forever",
        "zhengque": "membership level",
        "xuanxiang": "Member details",
        "chongzhi": "Yu'e Bao deposit and withdrawal records",
        "xiaoshi": "Yu'e Bao income",
        "yongjiu": "Yu’e Bao transfer",
        "yongjin": "Yu’e Bao transfer out",
        "renshu": "Yu'E Bao",
        "hezuo": "balance payment",
        "fenxiang": "Balance transfer",
        "chenggong": "balance",
        "tuijianID": "Hello , in order to protect your rights and interests, please bind the correct card number and branch information of the four major banks (Bank of China, Construction, Industry and Commerce, Agriculture). If you fill in the wrong information and the account cannot be received, this platform will not bear any responsibility! This platform does not support cash withdrawals from banks other than the four major banks.",
        "neirong": "Commission plus",
        "tuijian": "Commission rate"
    },
    "into_one": {
        "yibiaoban": "commission",
        "nihao": "Save QR code to local scan code",
        "yue": "Saved successfully",
        "shebeigong": "Save screenshots and scan the QR code to pay",
        "riqi": "Information announcement",
        "gaishu": "Modify name",
        "kaicaizong": "change Password",
        "xiaoshili": "Successfully modified",
        "rili": "Yuan",
        "zhouli": "Recharging",
        "yeli": "Recharging , please refresh the balance later",
        "tuilian": "Recharge and upgrade",
        "hezuo": "Recharge status",
        "fukuanxin": "Upgrade to unlock",
        "tianjiadi": "Recharge to unlock",
        "gengxin": "Recharge order pending payment",
        "yibiaoti": "Recharge record",
        "yaoqing": "Recharge instructions",
        "yaoqingren": "Please contact customer service for recharge",
        "shijian": "Recharge amount",
        "choujiangci": "top up",
        "choujianggai": "Recharge . Withdraw",
        "tuijianren": "free registration",
        "xiejie": "We are working hard to grab orders, and the results will be released below.",
        "jiriqi": "all products",
        "dianjifu": "Withdraw all",
        "tishi": {
            "1": "all",
            "2": "Freezing",
            "3": "If the submission is not confirmed within minutes, the system will freeze the order amount."
        },
        "chongzhijin": "point",
        "chongzhigai": "delete",
        "nindeyu": "Arrival time : 5 minutes",
        "mianchong": "remaining available assets",
        "mianchongci": "loading",
        "chongzhili": {
            "title": "update successed",
            "jine": "Go to upload",
            "shijian": "Go grab an order",
            "zhauntai": "Go to add"
        },
        "yijiangli": "Send the verification code",
        "yiqizhuan": "Cancel",
        "jianglili": "Available balance",
        "shezhi": "Available Balance",
        "mimashe": "treaties",
        "dangqianmishu": "cooperate",
        "xinmi": "name",
        "shuxinmi": "Enter the timeout state after",
        "quemi": "commodity",
        "shuquemi": "Mall homepage",
        "dainyou": "back to the homepage",
        "dianyoudi": "Team size",
        "shudainyou": "Team balance",
        "fukuanshe": "Team commission status",
        "bitedi": "Team total commission",
        "shugukuan": "Total team recharge",
        "jisheng": "Team total withdrawal",
        "qiangou": "Team order commission",
        "xiacixiaoshi": "Team reports",
        "yingjian": "Team flow",
        "zonggong": "Team management",
        "maidian": "team",
        "yingjiancheng": "Open in browser",
        "zhuanzhang": "Online payment",
        "dianfeizong": "area",
        "zhuanzhangti": "Copied successfully",
        "zhaunzhangfeiyong": "Copy link",
        "zuidifei": "clone",
        "tikuanjin": "sky",
        "zuidixian": "Avatar settings",
        "bijieshou": "avatar",
        "quezhi": "If you encounter problems and need assistance, please contact online customer service",
        "querenti": "Name",
        "yiwen": "deposit a sum",
        "tili": "The deposit amount does not meet the system requirements",
        "yaohaoyou": "deposits",
        "yaohuoci": "access history",
        "yihanwei": "official guarantee",
        "gongxihuo": "Officially provided"
    },
    "into_two": {
        "yibiaoban": "Regular financial management",
        "nihao": "Certainly",
        "yue": "Audit failure",
        "shebeigong": "examination passed",
        "riqi": "Customer Service",
        "gaishu": "customer service",
        "kaicaizong": "network",
        "xiaoshili": "Password management",
        "rili": "Dear user, in order to ensure the security of your funds, please bind your real name and set a withdrawal password. If the name does not match the account opening name, withdrawal will not be possible",
        "zhouli": "Decimal point must be filled in",
        "yeli": "hours, the system will automatically unfreeze after expiration",
        "tuilian": "Swipe left or right to see more",
        "hezuo": "Has been sent",
        "fukuanxin": "completed",
        "tianjiadi": "Revoked",
        "gengxin": "Please enter your email",
        "yibiaoti": "Already have an account? Log in",
        "yaoqing": "Already have an account, download now",
        "yaoqingren": "expired",
        "shijian": "passed",
        "choujiangci": "Dismissed",
        "choujianggai": "Start your path to wealth",
        "tuijianren": "Account holder",
        "xiejie": "Account opening agreement",
        "jiriqi": "Account Name",
        "dianjifu": "Account opening address",
        "tishi": {
            "1": "Account opening bank",
            "2": "Bank of deposit",
            "3": "Income of the day"
        },
        "chongzhijin": "Pending payment",
        "chongzhigai": "Pending",
        "nindeyu": "Pending review",
        "mianchong": "To be paid",
        "mianchongci": "Awaiting receipt",
        "chongzhili": {
            "title": "To be unlocked",
            "jine": "You can directly long press to identify the QR code on WeChat",
            "shijian": "forget the password",
            "zhauntai": "Quick cash withdrawal"
        },
        "yijiangli": "Total recharge",
        "yiqizhuan": "Total withdrawals",
        "jianglili": "Total revenue",
        "shezhi": "Total assets",
        "mimashe": "your balance",
        "dangqianmishu": "Your order will be placed on",
        "xinmi": "Your order has been frozen , please wait patiently",
        "shuxinmi": "Your order has expired and cannot be processed",
        "quemi": "your identity information",
        "shuquemi": "Your bank card information",
        "dainyou": "Are you sure you want to delete this address?",
        "dianyoudi": "You have not added bank card information yet",
        "shudainyou": "I have agreed to the \"Service Agreement\"",
        "fukuanshe": "I have completed payment",
        "bitedi": "I have understood and agreed",
        "shugukuan": "my balance",
        "jisheng": "my team",
        "qiangou": "my total assets",
        "xiacixiaoshi": "my cellphone number",
        "yingjian": "My Order",
        "zonggong": "My purse",
        "maidian": "My debit card",
        "yingjiancheng": "mine",
        "zhuanzhang": "Screenshot or directly",
        "dianfeizong": "Bank",
        "zhuanzhangti": "All goods",
        "zhaunzhangfeiyong": "all types",
        "zuidifei": "Mobile phone number is wrong",
        "tikuanjin": "Mobile phone number entered incorrectly",
        "zuidixian": "phone number",
        "bijieshou": "Phone number",
        "quezhi": "smartphone",
        "querenti": "handling fee",
        "yiwen": "Grabbing an order",
        "tili": "Order grabbing time",
        "yaohaoyou": "Order number",
        "yaohuoci": "Record of grabbing orders",
        "yihanwei": "Record",
        "gongxihuo": "Order grabbing instructions"
    },
    "into_s1": {
        "yibiaoban": "grab an order",
        "nihao": "Order quantity",
        "yue": "Commission rebate for taking orders",
        "shebeigong": "promotion poster",
        "riqi": "Recommended number of people",
        "gaishu": "Recommended products",
        "kaicaizong": "recommend",
        "xiaoshili": "submitting",
        "rili": "Submission successful , please wait patiently for review",
        "zhouli": "Submission successful , will be redirected soon",
        "yeli": "Submit Order",
        "tuilian": "submit",
        "hezuo": "Number of withdrawals",
        "fukuanxin": "Withdrawal status",
        "tianjiadi": "Withdrawal application has been submitted",
        "gengxin": "Withdrawals record",
        "yibiaoti": "Withdrawal rate",
        "yaoqing": "Withdrawal Amount",
        "yaoqingren": "Withdrawal limit",
        "shijian": "withdraw",
        "choujiangci": "search",
        "choujianggai": "payment method",
        "tuijianren": "Branch address",
        "xiejie": "recipient",
        "jiriqi": "Payee",
        "dianjifu": "income standard",
        "tishi": {
            "1": "Benefit type",
            "2": "Earnings record",
            "3": "Consignee name"
        },
        "chongzhijin": "Shipping address information",
        "chongzhigai": "Shipping address modification",
        "nindeyu": "Shipping address edit",
        "mianchong": "Shipping address",
        "mianchongci": "Receiving identity information",
        "chongzhili": {
            "title": "New people",
            "jine": "New Password",
            "shijian": "New mobile number",
            "zhauntai": "time"
        },
        "yijiangli": "Yesterday’s team commission",
        "yiqizhuan": "Yesterday's earnings",
        "jianglili": "No data",
        "shezhi": "No record yet",
        "mimashe": "More information",
        "dangqianmishu": "More",
        "xinmi": "The bank card is not bound , go to bind it",
        "shuxinmi": "No region entered, please set it",
        "quemi": "The account opening bank is not entered, please set it",
        "shuquemi": "Branch address not entered, please set it",
        "dainyou": "No phone number entered, please set it",
        "dianyoudi": "No phone number entered, please set it",
        "shudainyou": "No real name entered, please set it",
        "fukuanshe": "No detailed address entered, please set it",
        "bitedi": "No bank card number entered, please set it",
        "shugukuan": "is not entered , please set it",
        "jisheng": "This data is provided by",
        "qiangou": "The handling fee will be deducted for this withdrawal.",
        "xiacixiaoshi": "Loading",
        "yingjian": "Can take orders every day",
        "zonggong": "There is no QR code , please click",
        "maidian": "no data",
        "yingjiancheng": "No more content",
        "zhuanzhang": "No more data",
        "dianfeizong": "No record",
        "zhuanzhangti": "Registration time",
        "zhaunzhangfeiyong": "register",
        "zuidifei": "Note: Due to the large amount of recharge information, be sure to carefully check the account card number before recharging. This platform changes accounts from time to time. If you have any questions, please click online customer service",
        "tikuanjin": "activity Center",
        "zuidixian": "Number of active people",
        "bijieshou": "New shipping address",
        "quezhi": "Kind tips",
        "querenti": "state",
        "yiwen": "User recharge",
        "tili": "Username cannot be empty",
        "yaohaoyou": "User name input error , requires 2-12 letters or numbers",
        "yaohuoci": "User takes orders",
        "yihanwei": "User withdrawal",
        "gongxihuo": "telephone number"
    },
    "into_f": {
        "yibiaoban": "Login password",
        "nihao": "Log in",
        "yue": "Directly under",
        "shebeigong": "Directly under",
        "riqi": "actual name",
        "gaishu": "Confirm modification",
        "kaicaizong": "Confirm card binding",
        "xiaoshili": "Sure",
        "rili": "Confirm recharge",
        "zhouli": "Do you confirm the cancellation ? Cancellation will result in the amount being frozen.",
        "yeli": "Confirm Password",
        "tuilian": "Confirm to withdraw this amount to the balance? No interest will be calculated on undue withdrawals! , and deduct",
        "hezuo": "Confirm to exit?",
        "fukuanxin": "Return to my page in seconds",
        "tianjiadi": "Second",
        "gengxin": "Withdraw immediately",
        "yibiaoti": "buy now",
        "yaoqing": "upgrade immediately",
        "yaoqingren": "Set up now",
        "shijian": "Waiting confirmation from buyer",
        "choujiangci": "Waiting for buyer confirmation",
        "choujianggai": "Waiting for merchant system response",
        "tuijianren": "filter",
        "xiejie": "Introduction",
        "jiriqi": "system notification",
        "dianjifu": "The system is based on LBS technology and automatically matches products through the cloud.",
        "tishi": {
            "1": "System account",
            "2": "Cumulative income",
            "3": "Online recharge"
        },
        "chongzhijin": "Offline recharge",
        "chongzhigai": "Bind mobile phone number",
        "nindeyu": "Bind bank card",
        "mianchong": "statistics",
        "mianchongci": "Edit shipping address",
        "chongzhili": {
            "title": "Edit debit card",
            "jine": "edit",
            "shijian": "The network is not stable , please try again in a place with better signal",
            "zhauntai": "The network is unstable , please try again in a place with better signal"
        },
        "yijiangli": "Contact number",
        "yiqizhuan": "Go grab an order",
        "jianglili": "automatic",
        "shezhi": "Automatic calculation",
        "mimashe": "Self-operated mall",
        "dangqianmishu": "to",
        "xinmi": "Get verification code",
        "shuxinmi": "rule",
        "quemi": "Unlock",
        "shuquemi": "Order number",
        "dainyou": "The order has been frozen and the unfreezing time is",
        "dianyoudi": "Order has timed out",
        "shudainyou": "The total amount of orders",
        "fukuanshe": "Order total",
        "bitedi": "Order is being submitted",
        "shugukuan": "Orders submitted successfully",
        "jisheng": "order details",
        "qiangou": "Order",
        "xiacixiaoshi": "Remember password",
        "yingjian": "Set as common address",
        "zonggong": "Set as default",
        "maidian": "Set avatar",
        "yingjiancheng": "Details",
        "zhuanzhang": "Address",
        "dianfeizong": "Please upload payment voucher",
        "zhuanzhangti": "Please upload the recharge voucher",
        "zhaunzhangfeiyong": "Please check the payment information carefully",
        "zuidifei": "please pay",
        "tikuanjin": "Please change your name",
        "zuidixian": "Please be sure to keep the transfer amount to decimal points to avoid affecting the recharge time.",
        "bijieshou": "Please transfer and recharge to the following account",
        "quezhi": "Please consult online customer service after completing the recharge",
        "querenti": "Please fill in the recharge name",
        "yiwen": "Please fill in the recharge mobile phone number",
        "tili": "Please fill in the recharge amount",
        "yaohaoyou": "Please fill in your name",
        "yaohuoci": "please fill in cell phone number",
        "yihanwei": "Please fill in the correct mobile phone number",
        "gongxihuo": "Please fill in the detailed address"
    },
    "into_s": {
        "yibiaoban": "Please fill in the detailed delivery address",
        "nihao": "Please remember your password . If you forget your password, please contact customer service.",
        "yue": "Please ask online customer service (the platform changes accounts from time to time)",
        "shebeigong": "Please enter transaction password",
        "riqi": "Please enter the recharge amount",
        "gaishu": "Please enter the original password",
        "kaicaizong": "Please enter password",
        "xiaoshili": "Please enter the name of the account holder",
        "rili": "Please enter the account holder’s mobile phone number",
        "zhouli": "Please enter the account opening bank address",
        "yeli": "Please enter the account opening bank",
        "tuilian": "Please enter the bank where the account is opened",
        "hezuo": "Please enter your new password",
        "fukuanxin": "Please enter phone number",
        "tianjiadi": "Please enter the mobile phone verification code",
        "gengxin": "Please enter the referral code",
        "yibiaoti": "Please enter the withdrawal amount",
        "yaoqing": "Please enter the consignee's name",
        "yaoqingren": "Please enter a new password",
        "shijian": "Please enter your mobile phone number ",
        "choujiangci": "please enter user name",
        "choujianggai": "Please enter your login password",
        "tuijianren": "Please enter the SMS verification code",
        "xiejie": "Please enter your account /password",
        "jiriqi": "Please enter the fund password",
        "dianjifu": "Please enter the transfer amount",
        "tishi": {
            "1": "Please enter the invitation code",
            "2": "Please enter bank card number",
            "3": "please enter verification code"
        },
        "chongzhijin": "Please select payment channel",
        "chongzhigai": "Please select payment channel",
        "nindeyu": "Please select delivery address",
        "mianchong": "Please select the level you want to upgrade to",
        "mianchongci": "account balance",
        "chongzhili": {
            "title": "Account frozen amount",
            "jine": "Account details",
            "shijian": "Account amount",
            "zhauntai": "Proceeds from purchase"
        },
        "yijiangli": "Purchase without entering your real name, please set it up",
        "yiqizhuan": "When purchasing financial products , profits will not be calculated for malicious purchases, and handling fees will be charged.",
        "jianglili": "Buy",
        "shezhi": "Fund password",
        "mimashe": "Redirecting",
        "dangqianmishu": "To transfer money, please copy the message and go to online banking or Alipay to complete the transfer and recharge.",
        "xinmi": "Enter the recharge amount",
        "shuxinmi": "Enter name",
        "quemi": "Enter deposit amount",
        "shuquemi": "input mobile phone number",
        "dainyou": "Enter the fund password",
        "dianyoudi": "Returning",
        "shudainyou": "return",
        "fukuanshe": "No harvest address has been added yet",
        "bitedi": "No bank card added yet",
        "shugukuan": "Go into the store and have a look",
        "jisheng": "The remote host is allocating",
        "qiangou": "sign out",
        "xiacixiaoshi": "Choose recharge method",
        "yingjian": "Choose withdrawal method",
        "zonggong": "Select quantity",
        "maidian": "Choose financial products",
        "yingjiancheng": "invite friends",
        "zhuanzhang": "Join to get more benefits",
        "dianfeizong": "Invitation code",
        "zhuanzhangti": "Invitation link : click to copy",
        "zhaunzhangfeiyong": "Please check the payment information carefully",
        "zuidifei": "Financial card cash withdrawal",
        "tikuanjin": "Debit card account",
        "zuidixian": "bank card",
        "bijieshou": "Bank name",
        "quezhi": "question",
        "querenti": "If you need assistance, you can contact customer service to recharge manually.",
        "yiwen": "Need to pay back",
        "tili": "Estimated revenue",
        "yaohaoyou": "Expected return",
        "yaohuoci": "Number of people making first deposit",
        "yihanwei": "front page",
        "gongxihuo": "Recharge now"
    },
    "into_se": {
        "yibiaoban": "Verification code",
        "nihao": "default",
        "yue": "Please manually take a screenshot of the APP and save it locally to scan the QR code.",
        "shebeigong": "Please use APP manually",
        "riqi": "Home",
        "gaishu": "PasswordLogin",
        "kaicaizong": "Not submitted yet",
        "xiaoshili": "registration success",
        "rili": "Can be upgraded",
        "zhouli": "Unable to upgrade",
        "yeli": "Unable to upgrade if the upgrade conditions are not met",
        "tuilian": "You have reached the upgrade criteria and have completed the upgrade",
        "hezuo": "system notification",
        "fukuanxin": "Insufficient user balance",
        "tianjiadi": "Not enough invited users",
        "gengxin": "Upgrade conditions are not met",
        "yibiaoti": "The account balance required is greater than",
        "yaoqing": "invite",
        "yaoqingren": "to unlock",
        "shijian": "wallet address",
        "choujiangci": "Wallet scan available for transfer",
        "choujianggai": "Team commission today",
        "tuijianren": "APP download",
        "xiejie": "Recharge bonus",
        "jiriqi": "Please enter the TRC20 address",
        "dianjifu": "Please enter the ERC20 address",
        "tishi": {
            "1": "about Us",
            "2": "agent",
            "3": "rule"
        },
        "chongzhijin": "introduce",
        "chongzhigai": "Qualification",
        "nindeyu": "Surprise when opening the gift box",
        "mianchong": "Make money immediately",
        "mianchongci": "Old Password",
        "chongzhili": {
            "title": "Please enter old password",
            "jine": "Please enter password again",
            "shijian": "password has been updated",
            "zhauntai": "Failed to change password"
        },
        "yijiangli": "Please check the box to agree to the agreement",
        "yiqizhuan": "You have reached the upgrade criteria and have been automatically upgraded",
        "jianglili": "Downgraded due to balance change",
        "shezhi": "system notification",
        "mimashe": "trading order",
        "dangqianmishu": "Payment has been forced by the system. If you have any questions, please contact customer service",
        "xinmi": "Turn on automatic order grabbing",
        "shuxinmi": "Turn off automatic order grabbing",
        "quemi": "Duplicate username",
        "shuquemi": "Downgraded due to balance change",
        "dainyou": "You have reached the upgrade criteria and have been automatically upgraded",
        "dianyoudi": "Telephone",
        "shudainyou": "about Us",
        "fukuanshe": "View now",
        "bitedi": "platform",
        "shugukuan": "announcement",
        "jisheng": "Invite friends to earn cash",
        "chongxindenglu": "Please log in again",
        "pingtaijianjie": "Platform introduction",
        "pingtaijianjie1": "Order grabbing rules",
        "pingtaijianjie2": "Agency cooperation",
        "pingtaijianjie3": "Company qualifications"
    },
    "qing_sd": "Please wait",
    "loading1": "online proxy",
    "loading2": "request order",
    "loading3": "Grabbing an order",
    "goods": {
        "0": "green glass",
        "1": "Exclusive skin care products",
        "2": "Food grade plastic cup",
        "3": "classic perfume",
        "4": "imported coffee beans",
        "5": "Disney style bear"
    },
    "tab_name": {
        "0": "front page",
        "1": "Order record",
        "2": "Place an order",
        "3": "customer service",
        "4": "mine"
    },
    "pingjia": "evaluate",
    "login_t1": "One-stop shop for shopping around the world and earning rebates",
    "zhangh": "Please enter mobile phone",
    "email": "Email",
    "use_app": "Use App",
    "index_t1": "Extra 30% Off + 10% Cashback + Free Shipping on Your First App Purchase. T&Cs Apply",
    "qianbao": "wallet",
    "huoqu_yj": "Get commission",
    "zhangh_ye": "Account Balance",
    "zhangh_je": "account balance",
    "huoq_yj": "Get commission",
    "dingd_s": "quantity of order",
    "caoz_bz": "Steps",
    "caoz_t1": "1. Click the Start Task button and follow the prompts to complete the task.",
    "caoz_t2": "2. After completing the task, you can settle the commission to the balance",
    "kefu_t1": "If you have any questions or need help,",
    "kefu_t2": "Please contact online customer service to solve it for you",
    "kefu_t3": "Your dedicated customer service",
    "changj_wtjd": "Frequently Asked Questions",
    "changj_wt": {
        "0": {
            "name": "How to recharge and what payment methods are available ?",
            "value": "This system is open to multiple countries, and the international payment methods we provide include: USDT (ERC20). At the same time, we also support the national currencies of different countries."
        },
        "1": {
            "name": "How can I invest and earn income ?",
            "value": "You can participate in commodity transactions in the system and obtain stable transaction income every day. All income can be withdrawn to your bank card."
        },
        "2": {
            "name": "How to register as a member ?",
            "value": "An invitation system is used to register new members. In order to ensure the income of registered members and prevent over-registration from reducing income, new members can only register under the invitation of existing members."
        },
        "3": {
            "name": "Is there a limit on the purchase amount ?",
            "value": "Yes, in order to give more members the opportunity to earn profits, each account in the system has a minimum purchase limit."
        }
    },
    "yonghu_m": "username",
    "shoukuan_zh": "Accounts receivable",
    "youxiang": "Mail",
    "zhanghao": "account",
    "xiugai_mima": "change Password",
    "xuanze_yy": "Choose a language",
	queren:'confirm',
	bangka:'Please bind the payment account',
	xingy_d:'Xin chúc mừng, bạn đã có được một đơn hàng may mắn'
}